import React, { Component } from "react";
import { Tag } from "antd";
const { CheckableTag } = Tag;

class Cattag extends Component {
  //   constructor(props) {
  //     super(props);
  //     this.state = {
  //       checked: true
  //     };
  //   }

  handleChange = () => {
    this.props.callbackFromModal(this.props.rarity, this.props.catname);
  };

  render() {
    return (
      <CheckableTag
        {...this.props}
        checked={this.props.checked}
        onChange={this.handleChange}
        style={{ height: "38px", padding: "2px 4px", maxWidth: "230px" }}
      />
    );
  }
}

export default Cattag;



// WEBPACK FOOTER //
// ./src/components/multiplecats/Cattag.js